import initHeader from '../partials/header';
import {Fancybox} from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

document.addEventListener('DOMContentLoaded', () => {

    initHeader();

    Fancybox.bind("[data-fancybox]", {
        Toolbar: {
            display: {
                left: ["infobar"],
                middle: [],
                right: ["close"],
            },
        },
    });

    const btnSearch = document.querySelector('.btn-search');

    if (btnSearch) {
        btnSearch.addEventListener('click', function (e) {
            e.preventDefault();

            const baseUrl = this.getAttribute("href");

            const ciudad = document.getElementById('select_city').value || 'todo';
            const tipo = document.getElementById('select_type').value || 'todo';

            const subsidio = 'todo';
            const region = 'todo';

            const cleanBaseUrl = baseUrl.replace(/\/+$/, "");
            window.location.href = `${cleanBaseUrl}/${ciudad}/${tipo}/${region}`;
        });
    }

    const swiperElHero = document.querySelector('.swiper-hero');
    if (swiperElHero) {
        const swiperHero = new Swiper(swiperElHero, {
            slidesPerView: 1,
            spaceBetween: 0,
            direction: 'horizontal',
            modules: [Autoplay, Navigation, Pagination],
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination-hero",
                type: "fraction",
                formatFractionCurrent: (number) => number.toString().padStart(2, '0'),
                renderFraction: function (currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span>';
                },
            },
            navigation: {
                nextEl: ".swiper-next-hero",
                prevEl: ".swiper-prev-hero",
            },
        })
    }

    const swiperElOpportunities = document.querySelector('.swiper-opportunities');
    if (swiperElOpportunities) {
        const swiperOpportunities = new Swiper(swiperElOpportunities, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            modules: [Autoplay, Navigation],
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-next-opportunities",
                prevEl: ".swiper-prev-opportunities",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
            }
        });
    }

    const swiperElFeatured = document.querySelector('.swiper-featured');
    if (swiperElFeatured) {
        const swiperFeatured = new Swiper(swiperElFeatured, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            modules: [Autoplay, Navigation],
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-next-featured",
                prevEl: ".swiper-prev-featured",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
            }
        });
    }

    const swiperElBenefits = document.querySelector('.swiper-benefits');
    if (swiperElBenefits) {
        const swiperBenefits = new Swiper(swiperElBenefits, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            modules: [Autoplay, Navigation],
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-next-benefits",
                prevEl: ".swiper-prev-benefits",
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                1280:
                    {
                        slidesPerView: 2,
                        spaceBetween: 20
                    }
            }
        })
    }

    const swiperElPages = document.querySelector('.swiper-pages');
    if (swiperElPages) {
        const swiperPages = new Swiper(swiperElPages, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            modules: [Autoplay, Navigation],
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                prevEl: ".swiper-prev-pages",
                nextEl: ".swiper-next-pages",
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                }
            }
        })
    }
})
